var _circle, _g, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBuy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#13AE67",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4551_75606)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 25,
    height: 40,
    rx: 4,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8333,
    y: 16.8333,
    width: 23.3333,
    height: 38.3333,
    rx: 3.16667,
    stroke: "url(#paint0_linear_4551_75606)",
    strokeWidth: 1.66667
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 21.5,
    r: 1.5,
    fill: "#D7D7D7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 3,
    height: 3,
    rx: 0.416667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 42,
    width: 3,
    height: 3,
    rx: 0.416667,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 3,
    height: 3,
    rx: 0.416667,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 37,
    width: 3,
    height: 3,
    rx: 0.416667,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 3,
    height: 3,
    rx: 0.416667,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 38,
    width: 6,
    height: 6,
    rx: 0.833333,
    stroke: "white",
    strokeWidth: 1.66667
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 6,
    height: 6,
    rx: 0.833333,
    stroke: "white",
    strokeWidth: 1.66667
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 29,
    width: 6,
    height: 6,
    rx: 0.833333,
    stroke: "white",
    strokeWidth: 1.66667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4551_75606",
    x: 20.6667,
    y: 12.6667,
    width: 31.6667,
    height: 46.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4551_75606",
    x1: 25.6728,
    y1: 16,
    x2: 57.3007,
    y2: 24.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuy2);
export default __webpack_public_path__ + "static/media/ic-buy2.01b4c866c78af044c1864d8eed1ffd23.svg";
export { ForwardRef as ReactComponent };